<template>
  <span class="humidifierStateWidget" v-if="!disabled">
    <template v-if="value == 'ON'">
      <span title="Humidifer On">
        <v-icon
          :size="iconSize"
          color="primary"
        >
          grain
        </v-icon>
      </span>
    </template>
    <template v-else>
      <span title="Humidifier Off">
        <v-icon
          :size="iconSize"
          color="gray"
        >
          grain
        </v-icon>
      </span>
    </template>
  </span>
  <span v-else>
    <span title="No Humidifier Available">
      <v-icon
        :size="iconSize"
        color="rgba(128,128,128,0.3)"
      >
        grain
      </v-icon>
    </span>
  </span>
</template>

<script>
export default {
  name: "",
  props: ["value", "iconSize", "disabled"],
  components: {},
  beforeMount() {},
  mounted() {},
  data() {
    return {};
  },

  computed: {},
  watch: {},
  methods: {}
};
</script>
<style lang="scss"></style>
